import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { TicketTableItems } from "../../../../types/Miscellaneous";
import FilterComponent from "./FilterComponent";
import { TicketTableColumns, TicketTableData } from "../../../../data/miscellaneous/SupportTicket";

const TicketTable = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems: TicketTableItems[] = TicketTableData.filter((item: TicketTableItems) => {
    return Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase()));
  });
  return (
    <div className="table-responsive overflow-hidden">
      <FilterComponent onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} filterText={filterText} />
      <DataTable className="custom-scrollbar" data={filteredItems} columns={TicketTableColumns} pagination striped />
    </div>
  );
};
export default TicketTable;
